import {Injectable, Injector} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from "rxjs/Observable";
import {StorageFactory} from "../storage/storage.factory";
import {AuthTokenService} from "@core/auth/auth-token.service";
import {UnauthorizedAPIEvent} from "@events/UnauthorizedAPIEvent";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private storage: StorageFactory, private injector: Injector, private authTokenService: AuthTokenService,
              private unauthorizedAPIEvent : UnauthorizedAPIEvent) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // console.log("calling interceptor for: " + req.url);

    if( req.url.includes('auth/token') || req.url.includes('auth/refresh') ){
      // Bypass using the authorization token
      return next.handle(req);
    }

    return Observable.fromPromise(this.authTokenService.getAccessToken())
      .flatMap(token => {
        // console.log("token:" + JSON.stringify(token));
        if (token && token.token_type && !req.url.includes('AWSAccessKey')) {
          const authReq = req.clone({setHeaders: {Authorization: [token.token_type, token.access_token].join(' ')}});
          return next.handle(authReq);
        } else {
          return next.handle(req);
        }
      })
      .catch(err => {
        if (err instanceof HttpErrorResponse) {
          if (err.status === 401) {
            this.unauthorizedAPIEvent.fire();
          }
        }
        return Observable.throw(err);
      })
  }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/core/auth/auth.interceptor.ts